var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.35833 0 0 3.35833 0 7.5V13.3333C0 14.7167 1.11667 15.8333 2.5 15.8333H5V9.16667H1.66667V7.5C1.66667 4.275 4.275 1.66667 7.5 1.66667C10.725 1.66667 13.3333 4.275 13.3333 7.5V9.16667H10V15.8333H13.3333V16.6667H7.5V18.3333H12.5C13.8833 18.3333 15 17.2167 15 15.8333V7.5C15 3.35833 11.6417 0 7.5 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.a0386f269d81a0209b44773ab48135b8.svg";
export { ForwardRef as ReactComponent };